import React, { useEffect, useState } from "react";
import AuthService from "../../../../Service/auth.service";
import { useLoader } from "../../../../Context/LoaderContext";
import SubscriptionPlanDetails from "./SubscriptionPlanDetails";
import useAccess from "../../../../Hooks/useAccess";
import { Subscription } from "../../../../Entities/Subscription";
import "./SubscriptionDetails.scss";
import subscriptionService from "../../../../Service/subscription.service";

const SubscriptionDetails: React.FC = () => {
  const {
    currentPlan,
    currentSubscription,
    currentLimits,
    currentMode,
    currentAddons,
  } = useAccess();
  const user = AuthService.getInstance().getCurrentUser();
  const { setLoading, setLoadingMessage } = useLoader();
  const [paidSubscriptions, setPaidSubscriptions] = useState<Subscription[]>(
    []
  );

  const fetchPaidSubscriptions = async () => {
    try {
      setLoading(true);
      setLoadingMessage("Loading paid subscriptions...");
      const response = await subscriptionService.getSubscriptionByStatus(
        "paid"
      );
      setPaidSubscriptions(response);
    } catch (error: any) {
      console.error("🚀 ~ fetchPaidSubscriptions ~ error:", error);
    } finally {
      setLoading(false);
      setLoadingMessage(null);
    }
  };
  
  useEffect(() => {
    if (!currentPlan || !currentSubscription) {
      setLoading(true);
      setLoadingMessage("Loading subscription details...");
    } else {
      fetchPaidSubscriptions();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPlan, currentSubscription]);

  return (
    <section className="subscription-section-container">
      {currentPlan && currentSubscription && currentLimits && currentMode && (
        <SubscriptionPlanDetails
          plan={currentPlan}
          subscription={currentSubscription}
          addons={currentAddons}
          limits={currentLimits}
          user={user}
          subscriptionMode={currentMode}
          paidSubscriptions={paidSubscriptions}
        />
      )}
    </section>
  );
};

export default SubscriptionDetails;
